import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import {
  getVaultsByPool,
  SupportedChainId,
  SupportedDex
} from '@ichidao/ichi-vaults-sdk';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';
import { useConfig } from '@app/config';

async function fetcher(pool: string | undefined, _chainId: number | undefined) {
  if (!pool) {
    return null;
  }

  const dex = SupportedDex.Kim;
  const chainId =
    _chainId === SupportedChainId.mode
      ? SupportedChainId.mode
      : SupportedChainId.base;

  try {
    const res: { vault: string }[] = (await getVaultsByPool(
      pool,
      chainId,
      dex
    )) as unknown as { vault: string }[];

    return res.map(item => item.vault);
  } catch (e) {
    console.error(e);

    return null;
  }
}

export function useVaultsByPool(pool: string | undefined) {
  const chain = useSupportedChain();
  const config = useConfig();

  return useQuery<string[] | null | undefined>(
    [QueryKeys.GET_ICHI_VAULTS_BY_POOL, pool, chain?.chainId],
    () => fetcher(pool, chain?.chainId),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      enabled: !!pool && !!chain && !!config?.URLS.ichiAggregatorUrl
    }
  );
}
